/* @jsxRuntime automatic */
/* @jsxImportSource @superweb/css */

import { useTypo, useUiColors } from "@superweb/ui";
import { cssFns } from "@superweb/css";

import { Message, useMessage } from "#intl";

import { EmptyStatePlaceholder } from "./empty-state-placeholder";

export const Unexpected = ({
  reset,
  variant,
  traceId,
  titleId,
  size,
}: {
  reset?: () => void;
  variant?: "waitingMan";
  traceId?: string;
  titleId?: string;
  size?: "small" | "medium";
}) => {
  const uiColors = useUiColors();
  const typo = useTypo();
  const message = useMessage();

  return (
    <div
      css={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <EmptyStatePlaceholder
        {...(variant ? { variant } : { image: null })}
        size={size}
        title={
          <Message
            id="63cee1c0-f1bd-4245-9a6c-3cc0245fe030"
            context="Common error. Something went wrong. Title"
            default="Something went wrong"
          />
        }
        titleId={titleId}
        description={
          <div
            css={{
              display: "flex",
              flexDirection: "column",
              rowGap: "12px",
              maxWidth: "548px",
            }}
          >
            <Message
              id="ada3741a-6c41-4510-9050-8a0c3e6dd1f8"
              context="Common error. Something went wrong. Info"
              default="Try reloading, check back later, or contact Support"
            />
            {traceId && (
              <p
                css={{
                  color: uiColors.textMinor,
                  ...typo({
                    level: "body2",
                    density: "normal",
                    weight: "regular",
                  }),
                  ...cssFns.margin("0"),
                }}
              >
                {traceId}
              </p>
            )}
          </div>
        }
        buttons={
          reset && [
            {
              view: "outline",
              text: message({
                id: "0597cc88-4cf5-4bec-bc13-80ef1e98ef26",
                context:
                  "Common error. Something went wrong. Refresh button title",
                default: "Reload",
              }),
              onPress: reset,
            },
          ]
        }
      />
    </div>
  );
};
